var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera"},[_vm._m(0),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scanLoading),expression:"scanLoading"}],staticClass:"loading"},[_c('van-loading',{attrs:{"size":"24px","vertical":""}},[_vm._v("init camera...")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reader-box"},[_c('div',{staticClass:"reader",attrs:{"id":"reader"}})])
}]

export { render, staticRenderFns }